var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.314,
    height: 73.843,
    viewBox: "0 0 85.314 73.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189904",
    "data-name": "Group 189904",
    transform: "translate(-12.7 -17.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189906",
    "data-name": "Group 189906",
    transform: "translate(12.7 17.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42973",
    "data-name": "Path 42973",
    d: "M104.908,100.012c-3.468,0-6.936.009-10.4,0a2.282,2.282,0,0,1-2.612-2.585c-.025-1.734-.046-3.469,0-5.2a3.811,3.811,0,0,0-1.96-3.737,3.917,3.917,0,0,0-4.314.317c-4.006,2.556-8.043,5.061-12.067,7.59-2.523,1.586-5.051,3.165-7.563,4.77-3.047,1.947-3.1,5.164-.08,7.081q9.948,6.308,19.95,12.529c2.875,1.779,5.956.025,6.016-3.33.018-1.008,0-2.016.006-3.025a11.981,11.981,0,0,1,.016-1.329,2.06,2.06,0,0,1,2.18-1.963A1.864,1.864,0,0,1,96,113.144c.037,2.131.328,4.306-.187,6.387a7.965,7.965,0,0,1-11.979,4.855c-3.316-1.984-6.555-4.1-9.826-6.157-3.646-2.3-7.327-4.537-10.921-6.911a7.9,7.9,0,0,1-2.646-10.255,7.767,7.767,0,0,1,2.814-3.092c6.818-4.292,13.625-8.6,20.465-12.857A7.974,7.974,0,0,1,95.818,89.9a16.768,16.768,0,0,1,.2,4.812c-.028.988.314,1.2,1.244,1.193,5.766-.034,11.543-.21,17.3.044,11.995.529,21.1,6.164,26.7,16.725a30.9,30.9,0,0,1-19.626,44.331c-1.822.484-3.663,1.007-5.567.388a6.217,6.217,0,0,1-4.374-6.007c-.008-2.177,0-4.355,0-6.533,0-3.443,1.606-5.573,4.923-6.551a11.457,11.457,0,0,0,8.664-9.508,11.6,11.6,0,0,0-8.111-13.017,13.739,13.739,0,0,0-4.043-.542c-2.742.02-5.485.032-8.226-.016-1.87-.033-2.9-1.668-2.029-3.114a1.684,1.684,0,0,1,1.445-.956c4.1.023,8.23-.422,12.3.265a15.765,15.765,0,0,1,5.942,28.7,17.716,17.716,0,0,1-4.81,2.194c-1.517.453-1.937,1.018-1.944,2.611-.01,2.1-.031,4.195.007,6.291a2.155,2.155,0,0,0,2.808,2.259c10.612-2.315,17.813-8.527,20.964-18.971a26.917,26.917,0,0,0-20.454-33.938,52.071,52.071,0,0,0-10.233-.535c-1.331-.006-2.662,0-3.992,0Z",
    transform: "translate(-59.555 -83.833)",
    fill: "#6a3089"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon-undo.cf26b4436b616c2501fdb7b90300d87d.svg";
export { ForwardRef as ReactComponent };